import { lazy } from 'react';
import { authRoles } from 'app/auth';

const OrderAppConfig = {
	settings: {
		layout: {}
	},
	auth: [...authRoles.diller, ...authRoles.dillerHelper],
	routes: [
		{
			path: '/apps/diller/return-goods',
			exact: true,
			component: lazy(() => import('./single/Data'))
		},
		{
			path: '/apps/diller/return-goods/:groupId',
			exact: true,
			component: lazy(() => import('./details/Data'))
		}
	]
};

export default OrderAppConfig;
